<template>
  <div class="nlp__why-satoshi-box">
    <h2>
      Why <span>Satoshi Eye</span>
    </h2>
    <div class="nlp__why-satoshi-cards">
      <div
        v-for="(item, index) in whySatoshiData"
        :key="index"
        class="nlp__why-satoshi-card"
      >
        <div class="nlp__why-satoshi-card-row">
          <div class="nlp__why-satoshi-card-icon">
            <component :is="item.icon" />
          </div>
          <div class="nlp__why-satoshi-card-title">
            {{ item.title }}
          </div>
        </div>
        <div class="nlp__why-satoshi-card-text">
          <p>
            {{ item.description }}
          </p>
        </div>
      </div>
    </div>
    <div
      v-if="isMobileDevice() && !isPWAInstalled()"
      class="nlp__button-box"
    >
      <NlpButton
        primary
        text="Get Mobile Version"
        @button-click="installHandler"
      />
    </div>
  </div>
</template>

<script>
// Vuex
import { mapMutations } from "vuex";
// Components
import NlpWhySatoshiIcon1 from '@/pages/landing-page/svg/NlpWhySatoshiIcon1.vue'
import NlpWhySatoshiIcon2 from '@/pages/landing-page/svg/NlpWhySatoshiIcon2.vue'
import NlpWhySatoshiIcon3 from '@/pages/landing-page/svg/NlpWhySatoshiIcon3.vue'
import NlpWhySatoshiIcon4 from '@/pages/landing-page/svg/NlpWhySatoshiIcon4.vue'
import NlpButton from '@/pages/landing-page/ui-components/NlpButton.vue'
// Utils
import { isMobileDevice, isPWAInstalled } from "@/utils/pwa-support";

export default {
  name: 'NlpWhySatoshi',
  components: {
    NlpWhySatoshiIcon1,
    NlpWhySatoshiIcon2,
    NlpWhySatoshiIcon3,
    NlpWhySatoshiIcon4,
    NlpButton,
  },
  data() {
    return {
      whySatoshiData: [
        {
          title: 'Real-Time Data',
          icon: NlpWhySatoshiIcon1,
          description: 'Check risks in real time across legal services like exchanges and illegal sources like darknet, scams, and hacks.',
        },
        {
          title: 'Quick Checks',
          icon: NlpWhySatoshiIcon2,
          description: 'To check a wallet, simply enter the address and get the necessary info. There’s no extra setup or downloads.',
        },
        {
          title: 'Pro Tools Priced Right',
          icon: NlpWhySatoshiIcon3,
          description: 'Get expert-level features, a unique database, and up-to-date information without the big price.',
        },
        {
          title: 'Mobile-Friendly',
          icon: NlpWhySatoshiIcon4,
          description: 'Works great on smartphones and can be used like an app to check wallets anytime, anywhere.',
        },
      ],
    }
  },
  methods: {
    isPWAInstalled,
    isMobileDevice,
    ...mapMutations({
      SET_IS_PROMPT_OPEN: 'sidebar/SET_IS_PROMPT_OPEN',
    }),
    installHandler() {
      this.SET_IS_PROMPT_OPEN(true)
    },
  },
}
</script>

<style scoped>
.nlp__why-satoshi-box h2 {
  margin-bottom: 60px;
}

.nlp__why-satoshi-cards {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  position: relative;
}
.nlp__why-satoshi-card {
  flex: 1;
  min-width: 0;
  position: relative;
  z-index: 2;
}
.nlp__why-satoshi-card-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.nlp__why-satoshi-card-icon {
  width: 40px;
  min-width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid #E2E9F6;
  border-radius: 8px;
  box-shadow: 2px 2px 4px 0px #B8C2DB40;
}
.nlp__why-satoshi-card-title {
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: #1C1C1C;
}
.nlp__why-satoshi-card-text p {
  font-size: 16px;
}


@media (max-width: 1279px) {
  .nlp__why-satoshi-cards {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 48px;
  }
  .nlp__why-satoshi-cards::before,
  .nlp__why-satoshi-cards::after {
    content: '';
    background-color: #E2E9F6;
    position: absolute;
    z-index: 1;
  }
  .nlp__why-satoshi-cards::before {
    width: 100%;
    height: 1px;
    top: 50%;
    left: 0;
    transform: translate(0, -50%);
  }
  .nlp__why-satoshi-cards::after {
    width: 1px;
    height: 100%;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
  }
}
@media (max-width: 767px) {
  .nlp__why-satoshi-cards {
    display: block;
  }
  .nlp__why-satoshi-cards::before,
  .nlp__why-satoshi-cards::after {
    display: none;
  }
  .nlp__why-satoshi-card {
    text-align: center;
  }
  .nlp__why-satoshi-card + .nlp__why-satoshi-card {
    margin-top: 24px;
    padding-top: 24px;
    border-top: 1px solid #E2E9F6;
  }
  .nlp__why-satoshi-card-row {
    flex-direction: column;
    gap: 10px;
    margin-bottom: 8px;
  }
}
</style>
